export default __webpack_public_path__ + "static/media/betadda.66a59948.png";